import api from "api";
import PaginationWrapper from "component/Pagination";
import {InitiativeList} from "component/InitiativeList";
import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { createBrowserHistory, parsePath } from "history";
import { useLocation, useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import stateMap from "store/stateMap";
import update from 'immutability-helper';
import {ReactComponent as SVGArrowUp} from '../../../assets/arrow-up.svg';
import "./style.scss";
import Sidebar from "component/Sidebar";
import "component/FilterBoxes";
import { Link } from "react-router-dom";
import _ from "lodash";
import BlockHeader from "component/BlockHeader/BlockHeader";
import Breadcrumb from "component/Breadcrumb";
import { PageCredential } from "component/PageCredential";

export default connect(stateMap)((props) => {

    let location                                = useLocation();
    let history                                 = createBrowserHistory();
    
    const [initiatives, setInitiatives]         = useState(false);
    const [countInitiative, setCountInitiative] = useState(false);
    const [dataLoading, setDataLoading]         = useState(false) ;
    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');
    const [parameter, setParameter]             = useState({
        paged           : parseInt(queryString.get('page') || 1)  
        ,posts_per_page : parseInt(queryString.get('posts_per_page')) || 9
        ,type           : queryString.get('type') || ''
        ,initial_letter : queryString.get('initial_letter') || ''
        ,search         : queryString.get('search') || ''
    });
    useEffect(() => {
        
        update(parameter, {
            search : {$set : queryString.get('search')}
        });
        
    }, [queryString.get('search')])


    const changeParams = (e) => {
        e.preventDefault();

        if(dataLoading)
        {
            return;
        }

        let [toUpdateFilter, updatedValue] = e.currentTarget.name.split(':');

        setParameter(
            update(parameter, { $apply : function(params){

                if(params[toUpdateFilter] == updatedValue)
                {
                    params[toUpdateFilter] = '';
                }
                else
                {
                    params[toUpdateFilter] = updatedValue;
                }
    
                params.paged = 1;
    
                return _.assign({}, params);
    
            }})
        );
    }

    const loadInitiative = () => {

        if(dataLoading)
        {
            return;
        }

        var DataToLoad = [
            api('/initiative', 'get', parameter)
        ];

        if(parameter.paged === 1)
        {
            DataToLoad.push(
                api('/initiative', 'get', _.assign({get_total : 1}, parameter))
            );
        }

        setDataLoading(true);

        Promise.all(DataToLoad)
            .then((response) => {
                setDataLoading(false);

                setInitiatives(response[0].initiative);

                history.replace(
                    { search: `?${createSearchParams(parameter)}`}
                );

                if(parameter.paged === 1)
                {
                    setCountInitiative( parseInt(response[1].initiative) );
                }

            })
            .catch((error) => {
                setDataLoading(false);
                
            })
    }
    
    useEffect(loadInitiative, [props.auth.user, parameter]);

    return(
        <div id="initiative-archives" className="container relative">
            <PageCredential title="All Initiatives"/>
            <Sidebar>
                <div className="initiatives-filters filters-boxes">
                    <div className="filter-box">
                        <div className="wrapper">
                            <span className="filter-title">
                                Initiative Type <SVGArrowUp/>
                            </span>
                            <div className="filter-body">
                                <ul className="filter-items">
                                    <li className={`filter-item ${parameter.type == 'research' && 'active'}`}><a href="#" name="type:research" className="" onClick={changeParams} >Research</a></li>
                                    <li className={`filter-item ${parameter.type == 'event' && 'active'}`}><a href="#" name="type:event" className="" onClick={changeParams}>Event</a></li>
                                    <li className={`filter-item ${parameter.type == 'talent' && 'active'}`}><a href="#" name="type:talent" className="" onClick={changeParams}>Talent</a></li>
                                    <li className={`filter-item ${parameter.type == 'other' && 'active'}`}><a href="#" name="type:other" className="" onClick={changeParams}>Other</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="filter-box">
                        <div className="wrapper">
                            <span className="filter-title">
                                Sort By Name <SVGArrowUp/>
                            </span>
                            <div className="filter-body">
                                <ul className="filter-items grid">
                                    {
                                        ['all','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z']
                                        .map((alphabet) => (
                                            <li className={`filter-item ${parameter.initial_letter == alphabet && 'active'}`} key={alphabet}><a href="#" name={`initial_letter:${alphabet}`} onClick={changeParams} >{alphabet}</a></li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Sidebar>
            <div className="initiative-list-container">
                {
                    props.auth.user && 
                    <>
                        <div className="text-right">
                            <div>
                                <Link className="btn btn-primary btn-mini mb-sm" to={{
                                    pathname : "/create"
                                }}>Start Your Initiative Now</Link>
                            </div>
                        </div>
                        <hr />
                    </>
                }
                <Breadcrumb
                    items={[
                        ['/', 'Crowdbees']
                        ,['Initiatives']
                    ]}
                />
                <div className="initiatives-list">
                    {
                        initiatives === false ? <span className="skeleton"></span>:
                        (
                            <Fragment>
                                {
                                    dataLoading ? <div><span className="skeleton"></span></div> :
                                    <>
                                        {
                                            parameter.search && 
                                            <span className="block italic mb-md text-sm">Searching result for "{parameter.search}"</span>   
                                        }
                                        {
                                            parameter.type ? <BlockHeader title={ props.config.InitiativeTypes[parameter.type].name } desc={"About "+ countInitiative +" initiatives"}/>
                                            : <BlockHeader title="Initiatives" desc={"About "+ countInitiative +" initiatives"}/>
                                        }
                                        <InitiativeList initiatives={initiatives}/>
                                        <PaginationWrapper
                                            className="mt-4"
                                            activePage={parameter.paged}
                                            itemsCountPerPage={parameter.posts_per_page}
                                            totalItemsCount={countInitiative}
                                            pageRangeDisplayed={5}
                                            onChange={(pagenumber) => {
                                                setParameter(update(parameter, { paged : {$set : pagenumber } }))
                                            }}
                                        />
                                    </>
                                }
                            </Fragment>
                        )
                    }
                </div>
            </div>
        </div>
    )
});